import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {
    private mainMenuAreas: MainMenuAreaItem[] = [];
    private mainMenuAreasLookup = {};
    private menuItemsLookup = {};

    addMainMenuArea(id: string, text: string, icon: string, color: string, onNavigate?: () => void) {
        var item = new MainMenuAreaItem(this, text, icon, color, (id, item) => this.onChildAdded(id, item), onNavigate);
        this.mainMenuAreas.push(item);
        this.mainMenuAreasLookup[id] = item;
    }
    getMainMenuArea(id: string) {
        return this.mainMenuAreasLookup[id];
    }
    activateItem(id: string) {
        if (this.mainMenuAreasLookup[id]) {
            (<MainMenuAreaItem>this.mainMenuAreasLookup[id]).toggleOpen(true);
        }
        if (this.menuItemsLookup[id]) {
            (<MainMenuAreaItem>this.menuItemsLookup[id]).toggleOpen(true);
        }
    }

    onChildAdded(id: string, item: IMenuItem) {
        this.menuItemsLookup[id] = item;
    }
    onChildIsOpenChanged(child: IMenuItem) {
        if (this.currentlyActiveItem) {
            this.currentlyActiveItem.isActive = false;
            (<any>this.currentlyActiveItem).closeBranch();
        }
        this.currentlyActiveItem = child;
        this.currentlyActiveItem.isActive = true;
    }

    currentlyActiveItem: IMenuItem;
}

export interface IMenuItem {
    addSubMenuItem(id: string, text: string, onNavigate?: () => void);
    toggleOpen(open?: boolean): void;
    text: string;
    isOpen: boolean;
    isActive: boolean;
}

interface IMenuItemsParent {
    onChildAdded(id: string, child: IMenuItem): void;
    onChildIsOpenChanged(child: IMenuItem): void;
    closeBranch(): void;
}

abstract class MenuItemBase implements IMenuItem, IMenuItemsParent {
    private menuItems: IMenuItem[] = [];

    constructor(protected parent: IMenuItemsParent, public text: string, private onNavigate?: () => void) {}

    toggleOpen(open?: boolean) {
        if (open) {
            this.isOpen = true;
            if (this.onNavigate) {
                this.onNavigate();
            }
        } else {
            this.isOpen = false;
            this.menuItems.forEach(x => x.toggleOpen(false));
            this.parent.onChildIsOpenChanged(this);
        }
    }
    addSubMenuItem(id: string, text: string, onNavigate?: () => void) {
        let item = new MenuItem(this, text, onNavigate);
        this.menuItems.push(item);
        this.parent.onChildAdded(id, item);
    }
    closeBranch() {
        this.isOpen = false;
        this.parent.closeBranch();
    }
    onChildAdded(id: string, child: IMenuItem) {
        this.parent.onChildAdded(id, child);
    }
    onChildIsOpenChanged(child: IMenuItem) {
        if (child.isOpen && !this.isOpen) {
            this.isOpen = true;
            this.parent.onChildIsOpenChanged(child);
        }
    }

    isOpen: boolean;
    isActive: boolean;
}

class MainMenuAreaItem extends MenuItemBase {
    constructor(parent: MenuService, text: string, icon: string, public color: string, private childAdded: (id: string, item: IMenuItem) => void, onNavigate?: () => void) {
        super(<any>parent, text, onNavigate);
    }

    closeBranch() {
        this.isOpen = false;
    }
}

class MenuItem extends MenuItemBase {
    constructor(parent: IMenuItemsParent, text: string, onNavigate?: () => void) {
        super(parent, text, onNavigate);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/menu/menu.service.ts